import { forwardRef } from "react";
import type { EquiplyIconProps, EquiplyIcon } from "../types";

export const DocumentsIcon: EquiplyIcon = forwardRef<SVGSVGElement, EquiplyIconProps>(
  ({ size = 24, ...props }, ref) => (
    <svg
      ref={ref}
      width={size}
      height={size}
      viewBox="0 0 24 24"
      fill="none"
      {...props}
    >
      {/* Document */}
      <path
        d="M5 3.5h9l5 5v11.5a1.5 1.5 0 0 1-1.5 1.5h-12A1.5 1.5 0 0 1 4 20V5a1.5 1.5 0 0 1 1.5-1.5z"
        stroke="var(--equiply-icon-fg)" strokeWidth="1.5" strokeLinejoin="round"
      />
      {/* Coin replié */}
      <path
        d="M14 3.5V7a1.5 1.5 0 0 0 1.5 1.5H19"
        stroke="var(--equiply-icon-fg)" strokeWidth="1.5" strokeLinejoin="round"
      />
      {/* Bande titre menthe */}
      <rect x="7" y="11.5" width="9" height="2" rx="1" fill="var(--equiply-icon-bg)" />
      {/* Lignes */}
      <path
        d="M7 16.5h7"
        stroke="var(--equiply-icon-fg)" strokeWidth="1.5" strokeLinecap="round"
      />
    </svg>
  ),
);
DocumentsIcon.displayName = "DocumentsIcon";
